import { RestService } from 'app/shared/rest.service';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { NavigationEnd, Router, Routes } from "@angular/router";
import * as moment from "moment";
import { AuthService } from "../../../pages/com.usblick.common/auth/auth.service";
import { UsblickCommonEnum } from "../../../pages/com.usblick.common/usblick-common-enum";
import { AuthorizatedGuard } from "../../../pages/com.usblick.common/guard/authorizated.guard";
import { UserService } from "../../../pages/com.usblick.common/auth/user.service";
import { CookieService } from "ngx-cookie";
import { MatDialog } from "@angular/material/dialog";
import { FidelityService } from "../../../fidelity/fidelity.service";
import { AgentsService } from "../../../agents/agents.service";
import { AgentsSummaryService } from "../../../agents-summary/agents-summary.service";
import { ConfirmationModalComponent } from "../../../shared/modals/confirmation-modal/confirmation-modal.component";
import { setting } from "../../../../../setting";
import { Store } from "@ngrx/store";
import { AppState } from "app/core/profiles/storeProfile";
import { clearAuthState } from '../../profiles/profiles.actions';
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { FormOfflineComponent } from "app/shared/form-offline/form-offline.component";
import { ItineraryService } from "app/shared/itinerary.service";
import { HttpErrorResponse } from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ModalViewVideComponent } from "app/shared/modal-view-video/modal-view-video.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AppModule, ParamsSuggestionSystem } from "./models/suggestion-system.interface";
import { filter } from "rxjs/operators";
import { NotificationService } from 'app/shared/notifications/notification.service';




interface SidebarItem {
  label: string;
  action: () => void;
  permissionKey?: string;
  dividerAfter?: boolean;
}

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit,OnChanges {
  @Input() clientsSettings: any;
  @Input() namePaymentCondition: any;
  @Input() iconPaymentCondition: any;
  @Input() isAgencyPaymentCondition: boolean = false;
  @Input() creditDeposits: any = 0;
  @Input() creditBlickoins: any = 0;
  @Input() creditLimits: any = 0;
  @Input() permissionsMap: { [key: string]: boolean } = {};
  fechaa = moment().format("DD - MM - YYYY");
  menuHidden = true;
  isCollapsed = false;
  pointsAvailable: any = 0;
  items: SidebarItem[] = [];

  creditsDeposits: any = 0;
  notLogoHeader:any;

  public getClientsSettingAppBooking: any;
  public sectionHeader: any;

  public routeUploadFile: any;
  public apiRouteFile: any;

  public agencyLogo: any;
  public getClientsSettingAppAuth: any;
  public wsp_number: string;
  public moduleProfile: any[] = [];
  arraySocials:any[] = [];
  sidebarVisible = false;
  filterColorIcon: any;
  currencyAgency: any;
  currencies: any;
  sidebarSupportShow: boolean = false;
  sidebarSuggestionSystem: boolean = false;
  contactCommercial: any;

  bsModalRef?: BsModalRef;
  executiveData: any;
  bookingApiStorage: string;
selectedAgency: any;
  urlSafe: SafeResourceUrl;
  baseUrl:string = 'https://www.youtube.com/embed/';
  formSuggestionSystem: FormGroup;
  availableModules: AppModule[] = [];
  currentPath: string = '';

    isMainExpanded = true;
  expandedSegment: number | null = null
  helpSelected: any;

  private processedPaths = new Set<string>();

isMainExpandedExcutiveAction: boolean = false;
segmentClient: any[] = [];

infos: any[] = [
  "Cotizaciones personalizados de lujo (tailor-made / bespoke)",
  "Grupos especiales o viajes corporativos complejos",
  "Pasajeros VIP, VVIP o con requerimientos sensibles",
  "Amenidad de bienvenida personalizada en destino",
  "Negociación de condiciones especiales fuera de tarifario",
  "Experiencias exclusivas no estandarizadas en sistema",
  "Viajes con alto componente cultural, temático, gastronómicomico o de autor",
]

  constructor(
                private router: Router,
                private authenticationService: AuthService,
                private authorizatedGuard: AuthorizatedGuard,
                public userService: UserService,
                private _cookieService: CookieService,
                private _router: Router,
                public dialog: MatDialog,
                public fidelityService: FidelityService,
                public agentsService: AgentsService,
                public agentsSummaryService: AgentsSummaryService,
                private store: Store<AppState>,
                private cdr: ChangeDetectorRef,
                private modalService: BsModalService,
                private itineraryService: ItineraryService,
                private authService: AuthService,
                public sanitizer: DomSanitizer,
                private notificationService: NotificationService,
                private restService: RestService,
                private formBuilder: FormBuilder
              ) { }

  ngOnInit() {
    this.segmentClient = this.getSegmentClient();
    this.extractModulesFromRoutes();
    this.subscribeRouteParams();
    this.setRoutes();
    this.clientData();
    this.initFormSuggestionSystem();
    this.items = this.itemsConstructor();
    this.bookingApiStorage = setting.apiStorageBooking;
    this.currencies = this.userService?.currenciesExchange;
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getClientsSettingAppBooking = this.clientsSettings;
    this.currencyAgency = this.userService.currency;
    this.userService.creditBlickoins = this.userService.creditBlickoins;
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.selectedAgency = selectedAgency;
    if(selectedAgency) {
      if(selectedAgency?.contact_commercial) {
        this.contactCommercial = selectedAgency?.contact_commercial;
      } else {
        this.getContactCommercialData();
      }
      this.getExecutive(selectedAgency.executive);
    }
    this.cdr.detectChanges();
  }

  private getSegmentClient(): any[]{

    let segmentArr: any[] = JSON.parse(this.clientsSettings.clients_setting_app_booking?.section_segment)?.segments || [];

    return segmentArr;
  }

 private extractModulesFromRoutes(): void {
    this.availableModules = [];
    this.processedPaths.clear();

    const processRoutes = (routes: Routes, parentPath = '') => {
      routes.forEach(route => {
        // Ignorar rutas wildcard, rutas vacías y rutas con parámetros dinámicos
        if (route.path &&
            route.path !== '**' &&
            !route.path.includes(':') &&
            route.path !== '') {

          const fullPath = parentPath ? `${parentPath}/${route.path}` : `/${route.path}`;

          // Verificar si ya procesamos esta ruta (evitar duplicados)
          if (!this.processedPaths.has(route.path)) {
            this.processedPaths.add(route.path);

            // Usar data de la ruta si existe, sino generar automáticamente
            const moduleData: AppModule = {
              path: route.path,
              label: this.formatLabel(route.path),
              icon: route.data?.icon,
              description: route.data?.description
            };

            this.availableModules.push(moduleData);
          }
        }

        // Procesar rutas hijas recursivamente
        if (route.children) {
          const newParentPath = parentPath ? `${parentPath}/${route.path}` : route.path;
          processRoutes(route.children, newParentPath);
        }
      });
    };

    processRoutes(this.router.config);
    this.availableModules = this.availableModules.filter(c =>
      c.path !== 'dashboard' &&
      c.path !== 'multi-destination' &&
      c.path !== 'DetailsSummaryItinerary'
    );

    // Ordenar alfabéticamente por label
    this.availableModules.sort((a, b) => a.label.localeCompare(b.label));
  }

  private formatModuleName(path: string): string {
    return path.split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }

  private formatLabel(path: string): string {
    // Convertir "product-management" a "Gestión de Productos"

    switch(path) {
      case 'home': return 'Inicio';
      case 'results': return 'Resultados';
      case 'article': return 'Artículos';
      case 'itinerary-detail': return 'Fee';
      case 'summary': return 'File';
      case 'details-summary-itinerary': return 'Detalle de la reserva';
      case 'mannagement': return 'Menú';
      case 'daashboard': return 'Dashboard';
      case 'itinerary-reservation': return 'Formulario de pasajeros';
      case 'reservation-confirmation': return 'Selección de pasajeros';
      default: return 'Otro';
    }
  }

  private getCleanPath(url: string): string {
    // Remover query params y fragmentos
    return url.split('?')[0].split('#')[0];
  }

  private autoSelectModuleFromPath(): void {
    if (!this.currentPath || !this.formSuggestionSystem) return;

    // Buscar módulo que coincida con la ruta actual
    const matchingModule = this.availableModules.find(module =>
      this.currentPath.includes(module.path)
    );

    if (matchingModule) {
      this.formSuggestionSystem.patchValue({
        module: matchingModule.path
      });
    }
  }

    openSidebar() {
    this.sidebarVisible = true;
  }

  closeSidebar() {
    this.sidebarVisible = false;
  }

/**
 * Método para configurar las rutas de carga de archivos y almacenamiento.
 *
 * Este método establece las rutas utilizadas para cargar archivos y para acceder al almacenamiento
 * de la aplicación, tomando los valores de la configuración proporcionada en `setting`.
 *
 * @routeUploadFile-> Ruta para cargar los archivos.
 * @apiRouteFile-> Ruta para acceder al almacenamiento de los archivos de reservas.
 */
setRoutes(): void {
  this.routeUploadFile = setting.routeUploadFile;
  this.apiRouteFile = setting.apiStorageBooking;
}

/**
* Método para obtener los datos del cliente y configurar elementos relacionados.
*
* Este método establece el logo del encabezado en caso de no tener logo (con una imagen por defecto),
* obtiene el número de teléfono de WhatsApp del cliente, elimina el signo "+" y los espacios en blanco,
* y luego configura el número de WhatsApp (`wsp_number`). Además, extrae la configuración del encabezado
* de la sección desde la configuración de los clientes.
*
* @notLogoHeader-> Ruta de la imagen por defecto para el logo si no está disponible.
* @wsp_number-> Número de WhatsApp del cliente, con signos "+" y espacios eliminados.
* @sectionHeader-> Configuración del encabezado de la sección obtenida de la configuración del cliente.
*/
clientData(): void {
  this.notLogoHeader = "../../../../assets/img/sin-logo.png"

  let wspNumber = this.getClientsSettingAppBooking?.wsp_phone_number;

  // Eliminar el signo + y los espacios en blanco
  wspNumber = wspNumber.replace(/\+/g, '').replace(/\s/g, '');

  this.wsp_number = wspNumber;
  this.sectionHeader = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_header);
}

/**
* Método para determinar si se debe ocultar una sección según la ruta actual.
*
* Este método devuelve `true` si la ruta actual corresponde a una de las rutas específicas
* (`/article-one`, `/article-two`, `/article-three`), lo que indica que la sección debe ser oculta.
*
* @currentRoute-> Ruta actual de la aplicación.
* @returns-> `true` si se debe ocultar la sección, `false` en caso contrario.
*/
shouldHideSection(): boolean {
  const currentRoute = this.router.url;
  return currentRoute === "/article-one" || currentRoute === "/article-two" || currentRoute === "/article-three";
}

/**
* Método para alternar la visibilidad del menú.
*
* Este método invierte el valor de la variable `menuHidden`, controlando así la visibilidad del menú.
*
* @menuHidden-> Estado de la visibilidad del menú (oculto o visible).
*/
toggleMenu() {
  this.menuHidden = !this.menuHidden;
}

/**
* Método para cambiar el idioma de la aplicación.
*
* Este método establece el idioma de la aplicación. Actualmente, el código está comentado
* y no realiza ninguna acción, pero puede ser útil para futuras implementaciones de cambio de idioma.
*
* @language-> Idioma a establecer en la aplicación.
*/
setLanguage(language: string) {
  //this.i18nService.language = language;
}

/**
* Método para navegar a diferentes rutas según el valor proporcionado.
*
* Este método permite navegar a distintas rutas dependiendo del valor de `value`. Si el valor es
* "pointxagent", navega a la ruta `mannagement/fidelity`, y si el valor es "creditLimits",
* navega a la ruta `mannagement/credits-limit`.
*
* @value-> Valor que determina la ruta a la que navegar.
* @url-> Ruta a la que se navega según el valor de `value`.
*/
goTo(value: any) {
  let url;
  switch (value) {
    case "pointxagent":
      url = "mannagement/fidelity";
      break;
    case "creditLimits":
      url = "mannagement/credits-limit";
      break;
  }
  this._router.navigate([url]);
}

 /**
 * Método para cerrar sesión del usuario.
 *
 * Este método muestra un modal de confirmación para verificar si el usuario desea cerrar sesión.
 * Si el usuario confirma, se realiza la acción de logout, se elimina el token de autenticación,
 * se limpia el estado de autenticación en el store y se redirige al usuario a la página correspondiente.
 *
 * @initialState-> Estado inicial para el modal de confirmación.
 * @bsModalRef-> Referencia del modal de confirmación mostrado.
 * @confirmSubscription-> Suscripción a la respuesta del modal de confirmación.
 */
logout() {
  const initialState: ModalOptions = {
    initialState: {
      message: 'Saliendo de booking ¿Estás seguro?'
    }
  };

  this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
  const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
    if(result) {
      if (result) {
        this.authenticationService
          .logout({
            email: this.userService._email,
          })
          .subscribe(
            (data: any) => {
              this.store.dispatch(clearAuthState());
              //    localStorage.clear();
              this._cookieService.remove("clientActive");

                if (this.permissionsMap['booking.ingresosinagencia']) {
                  localStorage.removeItem("selectedAgency");
                  if(this.userService.itineraryActive && this.userService.itineraryActive.length > 0) {
                    this.itineraryService.updateActiveItinerary(this.userService.itineraryActive[0], false);

                    const itinerary =  this.itineraryService.getItinerary$();

                    itinerary.subscribe((data: any) => {
                      if(data.length === 0) {
                        this.authorizatedGuard.letsRedirect();
                      }
                    });
                  } else {
                    this.authorizatedGuard.letsRedirect();
                  }
                } else {
                  this.authorizatedGuard.letsRedirect();
                }
            },
            (error) => {
              console.log(error)
              this.store.dispatch(clearAuthState());
              localStorage.removeItem("selectedAgency");
              this.authorizatedGuard.letsRedirect();
            }
          );
      } else {
        console.log("no dijo nada");
      }
    } else {

    }
    confirmSubscription.unsubscribe();
  });
}

/**
* Método para navegar a la página de itinerarios.
*
* Este método redirige al usuario a la ruta `itinerary` para mostrar la página de itinerarios.
*/
itinerary() {
  this.router.navigate(["itinerary"]);
}

/**
* Método para navegar a la página principal (home).
*
* Este método redirige al usuario a la página principal de la aplicación.
*/
_home() {
  this.router.navigate(["/"]);
}

/**
* Método para obtener el nombre del usuario.
*
* Este método obtiene el nombre del usuario desde el servicio `userService`.
* Si el nombre no está disponible, retorna `null`.
*
* @returns-> El nombre del usuario si está disponible, de lo contrario, `null`.
*/
get username(): string {
  const name = this.userService._name;
  return name ? name : null;
}

/**
* Método para obtener el nombre de la agencia.
*
* Este método obtiene el nombre de la agencia desde el servicio `userService`.
* Si el nombre no está disponible, retorna `null`.
*
* @returns-> El nombre de la agencia si está disponible, de lo contrario, `null`.
*/
get agencyName(): string {
  const agencyName = this.userService._agencyName;
  return agencyName ? agencyName : null;
}

/**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.apiRouteFile || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

/**
* Método para manejar el error de carga de imagen.
*
* Este método establece una imagen alternativa en caso de que la imagen de la agencia no se cargue correctamente.
*
* @event-> Evento que se dispara cuando ocurre un error en la carga de la imagen.
*/
onImageError(event: Event): void {
const imgElement = event.target as HTMLImageElement;
imgElement.src = 'assets/img/sin-logo.png'; // Imagen alternativa
}

/**
* Método para navegar a la página de itinerarios de gestión.
*
* Este método redirige al usuario a la ruta `/management/10` para acceder a la página de itinerarios de gestión.
*/
goItinerary() {
  this._router.navigate(["/management", 10]);
}

/**
* Método para redirigir a una página de gestión específica según la opción proporcionada.
*
* Este método redirige al usuario a una ruta de gestión específica basada en la opción proporcionada.
*
* @mannagementOption-> Opción de gestión que define a qué ruta se debe redirigir al usuario.
*/
mannagementRedirect(mannagementOption: any, typeOption: number) {
  this.closeSidebar();
  switch(typeOption) {
    case 1:
      if(mannagementOption === 'events') {
        window.open('https://moebius.tur.ar/eventos', '_blank');
      } else {
        this.router.navigate([`mannagement/${mannagementOption}`]);
      }
      break;
    case 2:
      this.router.navigate([`shortCutsMannager/${mannagementOption}`]);
      break;
  }

}

/**
* Método para navegar a la página de inicio (home).
*
* Este método redirige al usuario a la página de inicio de la aplicación.
*/
goHome() {
  this.closeSidebar();
  this._router.navigate(['home']);
}

itemsConstructor(): any {
  return [
    {
      label: 'Inicio',
      action: () => this.goHome(),
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Cuenta',
      action: () => this.mannagementRedirect('account', 1),
      permissionKey: 'booking.cuenta.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Clientes',
      action: () => this.mannagementRedirect('clients', 1),
      permissionKey: 'booking.clientes.habilitar',
      client: true,
      dividerAfter: true,
    },
    //     {
    //   label: 'Promociones',
    //   action: () => this.mannagementRedirect('promotions', 1),
    //   // permissionKey: 'booking.clientes.habilitar',
    //   client: true,
    //   dividerAfter: true,
    // },
    {
      label: 'Blickoins',
      action: () => this.mannagementRedirect('fidelity', 1),
      permissionKey: 'booking.blickoins.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Mi Billetera',
      action: () => this.mannagementRedirect('wallet', 1),
      // TODO: descomentar cuando exista el permiso 'booking.wallet.habilitar' en backend.
      // permissionKey: 'booking.wallet.habilitar',
      client: true,
      dividerAfter: true,
    },
    // <!-- <li role="menuitem"><a class="dropdown-item" href="#credits">Creditos</a></li>
    //         <li class="divider dropdown-divider"></li> -->
    //         <!-- <li *ngIf="limitCreditAccess" role="menuitem"><a class="dropdown-item" href="#credits-limit">Límite de crédito</a></li>
    //         <li *ngIf="limitCreditAccess" class="divider dropdown-divider"></li> -->
    {
      label: 'Depósitos de garantías',
      action: () => this.mannagementRedirect('depositWarranty', 1),
      permissionKey: 'booking.depositoengarantia.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Transacciones',
      action: () => this.mannagementRedirect('transactions', 1),
      permissionKey: 'booking.transacciones.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Pagos',
      action: () => this.mannagementRedirect('payments', 1),
      permissionKey: 'booking.pagos.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Condiciones de pago',
      action: () => this.mannagementRedirect('agencyPaymentCondition', 1),
      permissionKey: 'booking.condicionespago.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Files',
      action: () => this.mannagementRedirect('itineraries', 1),
      permissionKey: 'booking.itinerarios.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Vuelos',
      action: () => this.mannagementRedirect('flyItineraries', 1),
      permissionKey: 'booking.itinerarios.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Solicitudes offline',
      action: () => this.mannagementRedirect('requestOffline', 1),
      permissionKey: 'booking.itinerarios.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Recibos',
      action: () => this.mannagementRedirect('request-receipts', 1),
      permissionKey: 'booking.itinerarios.habilitar',
      client: true,
      dividerAfter: true,
    },
    {
      label: 'Solicitudes de facturación',
      action: () => this.mannagementRedirect('request-billed', 1),
      permissionKey: 'booking.itinerarios.habilitar',
      client: true,
      dividerAfter: true,
    },
    // <!-- <li *ngIf="permissionsMap['booking.dashboard.habilitar']" role="menuitem"><p class="dropdown-item mb-0" style="cursor:pointer" (click)="mannagementRedirect('request-billed')">Solicitudes de facturación</p></li> -->
    //           <!-- <li *ngIf="permissionsMap['booking.itinerarios.habilitar']" class="divider dropdown-divider"></li> -->
    // {
    //   label: 'Dashboard',
    //   action: () => this.mannagementRedirect('dashboard', 1),
    //   permissionKey: 'booking.dashboard.habilitar',
    //   client: true,
    //   dividerAfter: true,
    // },
    {
      label: 'Eventos',
      action: () => this.mannagementRedirect('events', 2),
      client: this.clientsSettings.name === 'Moebius' ? true : false,
      dividerAfter: true,
    },
    {
      label: 'Paquetes',
      action: () => this.mannagementRedirect('circuit', 2),
      client: this.clientsSettings.name === 'Moebius' ? true : false,
      dividerAfter: true,
    },
    {
      label: 'Tarifario',
      action: () => this.mannagementRedirect('rate', 2),
      client: this.clientsSettings.name === 'Moebius' ? true : false,
      dividerAfter: true,
    },
    {
      label: 'Herramientas',
      action: () => this.mannagementRedirect('tools', 2),
      client: this.clientsSettings.name === 'Moebius' ? true : false,
      dividerAfter: true,
    },
    {
      label: 'Nacionales',
      action: () => this.mannagementRedirect('national', 2),
      client: this.clientsSettings.name === 'Moebius' ? true : false,
      dividerAfter: true,
    },
    {
      label: 'Promociones',
      action: () => this.mannagementRedirect('deals', 2),
      client: this.clientsSettings.name === 'Moebius' ? true : false,
    },
  ];
}

openSuggestionSystem(): void {
  this.sidebarSuggestionSystem = true;
}

closeSuggestionSystem(): void {
  this.sidebarSuggestionSystem = false;
}

openModalFormOffline(): void {
    const dialogRef = this.dialog.open(FormOfflineComponent, {
      disableClose: true,
      width: '80%',
      maxHeight: '90vh', // Establece una altura máxima
      data: {clientSetting: this.clientsSettings}
    });
}

subscribeRouteParams(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentPath = this.getCleanPath(event.url);
      this.autoSelectModuleFromPath();
    });

    // Inicializar con la ruta actual
    this.currentPath = this.getCleanPath(this.router.url);

    this.autoSelectModuleFromPath();
}

initFormSuggestionSystem(): void {

  const currentPath = this.availableModules.find(c => c.path === this.currentPath);

  this.formSuggestionSystem = this.formBuilder.group({
    module: new FormControl(currentPath?.label, Validators.required),
    title: new FormControl(null, [Validators.required, Validators.maxLength(30)]),
    description: new FormControl(null, [Validators.required, Validators.maxLength(200)]),
    contact_available: new FormControl(null, Validators.required)
  });
}

sidebardSupport(): void {
  this.sidebarSupportShow = true;
  this.formSuggestionSystem.reset();
}

closeSidebardSupport(): void {
  this.sidebarSupportShow = false;
  this.formSuggestionSystem.reset();
}

sendSuggestionSystem(): void {

if(this.formSuggestionSystem.valid) {
  const initialState: ModalOptions = {
      initialState: {
        message: '¿Enviar sugerencia?',
      },
    };

this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

    const confirmSubscription = this.bsModalRef.content?.confirmResult.subscribe((result: boolean) => {
      if(result) {

        const formsuggestionSystem: ParamsSuggestionSystem = {
          client_id: this.userService.clientIdFusion,
          application_id: 2,
          user_id: this.userService._agentID,
          module: this.formSuggestionSystem.get('module').value,
          title: this.formSuggestionSystem.get('title').value,
          description: this.formSuggestionSystem.get('description').value,
          contact_available: this.formSuggestionSystem.get('contact_available').value
        }

        this.restService.doPost('app', 'client-system-suggestion', formsuggestionSystem).subscribe({
          next: (res: any) => {
            console.log(res);
            if(res?.data && res?.data?.title) {
                    this.notificationService.success('Su sugerencia ha sido enviada');
                    this.formSuggestionSystem.reset();
                    this.sidebarSuggestionSystem = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
          }
        });


      } else {
        return;
      }
    });

} else {
  this.notificationService.info('Faltan datos obligatorios por completar');
}
}

resetFormSuggestionSysytem(): void {
  this.formSuggestionSystem.reset();
}

getExecutive(executiveId: number): void {
  this.authService.getExecutive(executiveId).subscribe({
    next: (res: any) => {
      if(res) {
        this.executiveData = res;
        if(this.executiveData?.video_profile) {
          // console.log(`${this.baseUrl}${this.executiveData?.video_profile}`)
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.baseUrl}${this.executiveData?.video_profile}`);
        }
      }
    },
    error: (error: HttpErrorResponse) => {
      console.log(error);
    }
  })
}

getDay(numberDay: number): string {
  if(numberDay === 0) {return 'Domingo';}
  if(numberDay === 1) {return 'Lunes';}
  if(numberDay === 2) {return 'Martes';}
  if(numberDay === 3) {return 'Miércoles';}
  if(numberDay === 4) {return 'Jueves';}
  if(numberDay === 5) {return 'Viernes';}
  if(numberDay === 6) {return 'Sábado';}
}

getContactCommercialData(): void {
  this.contactCommercial = {
    first_name: this.selectedAgency.first_name_com || null,
    last_name: this.selectedAgency.last_name_com || null,
    email: this.selectedAgency.email_com || null,
    phone_code: this.selectedAgency.phone_cc_code || null,
    phone: this.selectedAgency.phone_com || null,
    day_from: this.selectedAgency.day_from_com || null,
    day_to: this.selectedAgency.day_to_com || null,
    hour_from: this.selectedAgency.hour_from_com || null,
    hour_to: this.selectedAgency.hour_to_com || null
  };
}

/**
 * Método que abre un modal para mostrar un video.
 *
 * Este método obtiene el `idVideo` de un enlace de YouTube utilizando el método `getIdVideoYt` y luego abre un
 * modal de tipo `ModalViewVideComponent` para mostrar el video. El modal tiene un tamaño de 700px de ancho.
 *
 * @data -> Objeto que contiene la URL del video a mostrar en el modal.
 * @returns Ninguno. Abre un modal para reproducir el video de YouTube.
 */
openVideoModal(data: any) {

  if(!data) {
    this.notificationService.info('El ejecutivo de ventas no cuenta con video de presentación');
    return;
  }
  const idVideo = data;

  var dialogRef = this.dialog.open(ModalViewVideComponent, {
    width: "700px",
    data: idVideo,
  });
  dialogRef.afterClosed().subscribe((result) => {
    // Puede manejar el resultado aquí si es necesario
  });
}


/**
   * Alternar acordeón principal
   */
  toggleMainAccordion(): void {
    this.isMainExpanded = !this.isMainExpanded;
    if (!this.isMainExpanded) {
      this.expandedSegment = null; // Cerrar todos los segmentos si se cierra el principal
    }
  }

  /**
   * Alternar segmento específico
   * @param index Índice del segmento
   */
  toggleSegment(index: number): void {
    if (this.expandedSegment === index) {
      this.expandedSegment = null;
    } else {
      this.expandedSegment = index;
    }
  }

  executiveHelpSelected(event: any): void {
    this.helpSelected = event;
  }

openEmailWithSubject(event: any, executive: boolean): void {
    // Prevenir el comportamiento por defecto del enlace
    event.preventDefault();

    let email: string = '';

    if(executive) {
      email = this.executiveData.email;
    } else {
      email = event.target.text.trim();
    }
    // const email = this.executiveData.email;

    // Usar el valor del select almacenado en helpSelected
    const selectedSubject = this.helpSelected;

    if (!selectedSubject || selectedSubject === 'null') {
        // Si no hay asunto seleccionado, abre sin asunto
        window.location.href = `mailto:${email}`;
        return;
    }

    // Codificar el asunto para URL
    const encodedSubject = encodeURIComponent(selectedSubject);


    if(executive) {
      window.location.href = `mailto:${email}?subject=${encodedSubject}`;
    } else {
      window.location.href = `mailto:${email}`;
    }
}

openWhatsApp(): void {
    if (!this.executiveData?.phone) {
        return;
    }
    // Formatear número (eliminar espacios, guiones, paréntesis)
    const rawNumber = (this.executiveData.phone_code_wsp + this.executiveData.wsp_phone_number)
        .replace(/\s+/g, '')
        .replace(/[()\-]/g, '');

    let message = 'Hola, buen día!';
    // Personalizar mensaje según el asunto seleccionado
    if (this.helpSelected && this.helpSelected !== 'null') {
        message = `Hola! Me comunico por: ${this.helpSelected}\n\n`;
    }

    // Opcional: agregar información adicional
    message += `\n\nSaludos.\n`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${rawNumber}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');
}

toggleMainAccordionExcutiveAction(): void {
  this.isMainExpandedExcutiveAction = !this.isMainExpandedExcutiveAction;
}

changeAgencyActive(): void {
  if(!this.permissionsMap['booking.ingresosinagencia']) {
    return;
  }

  this.authService.openAgencyModal();

}

}
